<template>
    <div class="card">
        <div class="card-header">
            <p class="card-header-title">
                {{ trans.element.new_base }}
            </p>
        </div>
        <div class="card-content">

            <div class="notification is-success has-text-centered" v-show="success">
                <button class="delete" @click="success = false"></button>
                {{ trans.msg.success }}
            </div>

            <form method="POST" :action="action" @submit.prevent="submit"
                  @input="clearValidation" novalidate
            >
                <slot><!--CSRF--></slot>

                <div class="field is-horizontal is-required">
                    <label for="name" class="field-label is-normal">
                        {{ trans.element.name }}
                    </label>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input id="name" v-model="form.name"
                                       class="input" :class="[errors.name ? 'is-danger' : '']"
                                       type="text" name="name" required
                                   >
                            </div>
                            <p v-show="errors.name" class="help is-danger">
                                {{ errors.name }}
                            </p>
                        </div>
                    </div>

                </div>

                <div class="field is-horizontal">
                    <label for="description" class="field-label is-normal">
                        {{ trans.element.description }}
                    </label>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <textarea id="description" v-model="form.description"
                                          class="textarea" :class="[errors.description ? 'is-danger' : '']"
                                          name="description" required
                                ></textarea>
                            </div>
                            <p v-show="errors.description" class="help is-danger">
                                {{ errors.description }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label"></div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <button type="submit" class="button is-info"
                                        :class="[isLoading ? 'is-loading' : '']"
                                        :disabled="isLoading"
                                >
                                    {{ trans.element.create_button }}
                                </button>
                                <a :href="cancel_route" class="button is-outlined" v-if="!isAdmin24Context">
                                    {{ trans.element.cancel }}
                                </a>
                            </div>
                        </div>
                        <p v-show="errors.unexpected" class="help is-danger">
                            {{ errors.unexpected }}
                        </p>
                        <p v-show="errorMessage" class="help is-danger">
                            {{ errorMessage }}
                        </p>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import { axiosForm } from '../mixins/axiosFormMixin.js';

    export default {
        mixins: [axiosForm],
        data() {
            return {
                success: false,
                form: {
                    name: null,
                    description: null,
                },

                okReport: 'Создана новая база',
                failReport: 'Ошибка создания базы',
                errorMessage: false,
                isAdmin24Context: isAdmin24Context
            }
        },
        methods: {
            postResultHandler(result) {
                if (result.data.error_message) {
                    this.errorMessage = result.data.error_message;
                    return;
                }

                this.success = true;
                this.form.name = null;
                this.form.description = null;

                let url = '';
                if (isBx24Context || isPortalContext && !isAdmin24Context) {
                    url = actions.showAttachUsersForm.replace(
                        'base_hash',
                        result.data.hash_id
                    );
                } else {
                    url = actions.baseList;
                }
                document.location.href = url;
            }
        }
    }
</script>
